module.exports = new __parcel__URL__("pentest.8c0b9765.jpg").toString();